<div class="online-courses" *ngIf="onlineCourses$ | async as onlineCourses">
  <lx-price-lists-portal-price-list-panel [withData]="productsAvailable">
    <h2 class="online-courses__title">Online Courses</h2>
    <div class="online-courses__price-list">
      <div class="online-courses__price-list__header">
        <div class="online-courses__price-list__header__title">Kaplan Online English</div>
        <div class="online-courses__price-list__header__terms">
          <lx-price-lists-portal-price-lists-popup title="Terms & Conditions" [company]="company">
            <lx-price-lists-portal-terms-and-conditions [company]="company"></lx-price-lists-portal-terms-and-conditions>
          </lx-price-lists-portal-price-lists-popup>
        </div>
      </div>
      <lx-price-lists-portal-pricelist-online-options-product
        [dataSource]="onlineCourses?.courses?.products"
        tableTitle="Individuals"
      ></lx-price-lists-portal-pricelist-online-options-product>
      <lx-price-lists-portal-notes *ngIf="coursesNotes.length > 0" [company]="company" [notes]="coursesNotes"></lx-price-lists-portal-notes>
      <lx-price-lists-portal-pricelist-online-options-product
        [dataSource]="onlineCourses?.privateLessons?.products"
        tableTitle="Private (Price Per Student)"
      ></lx-price-lists-portal-pricelist-online-options-product>
      <lx-price-lists-portal-notes *ngIf="privateLessonsNotes.length > 0" [company]="company" [notes]="privateLessonsNotes"></lx-price-lists-portal-notes>
    </div>
  </lx-price-lists-portal-price-list-panel>
</div>
